import React, { Component } from "react";
import _ from "lodash";
import TimeStamp from "react-timestamp";
// React-bootstrap
import { Button } from "react-bootstrap";
// No Data Found
import NoDataFound from "../Errors/NoDataFound";
// Loading
import Loading from "../../components/Loading/Loading";
// Authorization
import withAuthorization from "../../components/Authorization/withAuthorization";
// Firebase
import { doGetLocklist, fire, auth } from "../../firebase/index";
//? import chatbot
// import Chatbot from "../../views/Chatbot/Chatbot";
import axios from "axios";
import "../../routes/app";
import {
  BootstrapTable,
  TableHeaderColumn,
  SearchField,
  SizePerPageDropDown,
} from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table.min.css";
import { confirmAlert } from "react-confirm-alert";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";
import SwitchBtn from "./SwitchBtn";
import ApprovalBtn from "./ApprovalBtn";

import { customLog } from "../../variables/Variables";
//css
import "../../assets/css/maincss.css";
import "../../assets/css/header.css";
import "react-confirm-alert/src/react-confirm-alert.css";

import LocalizedStrings from "react-localization";
let localizationStrings = new LocalizedStrings({
  en: {
    multiApproveTitle: "Multi Approval",
    multiApproveDescription: "Grant or retract approval",
    retractDescription2: "",
    shareFromHeader: "Share From",
    shareToHeader: "Share To",
    lockNameHeader: "Lock Name",
    lockSerialHeader: "Lock Serial",
    startHeader: "Start",
    endHeader: "End",
    allowAccessHeader: "Allow Access",
    resultTitle1: "Showing ",
    resultTitle2: " to ",
    resultTitle3: " of ",
    resultTitle4: " Results",
    removeSelectedBtn: "Remove Selected",
    approvalStatusHeader: "Approval Status",
    searchPlaceholder: "Search",
  },
  ja: {
    multiApproveTitle: "承認",
    multiApproveDescription: "承認を付与または撤回する",
    retractDescription2: "",
    shareFromHeader: "フォームを共有",
    shareToHeader: "共有先",
    lockNameHeader: "ロックの名称",
    lockSerialHeader: "ロックシリアルNo",
    startHeader: "開始",
    endHeader: "完了",
    allowAccessHeader: "アクセス許可",
    resultTitle1: "表示 ",
    resultTitle2: " へ",
    resultTitle3: " の ",
    resultTitle4: " 結果",
    removeSelectedBtn: "選択を取り消す",
    approvalStatusHeader: "承認状況",
    searchPlaceholder: "検索",
  },
  es: {
    multiApproveTitle: "Aprobación Múltiple",
    multiApproveDescription: "Conceder o retractar aprobación",
    retractDescription2: "",
    shareFromHeader: "Compartir Desde",
    shareToHeader: "Compartir A",
    lockNameHeader: "Nombre de la Candado",
    lockSerialHeader: "Número de Serie de la Candado",
    startHeader: "Inicio",
    endHeader: "Fin",
    allowAccessHeader: "Permitir Acceso",
    resultTitle1: "Mostrando ",
    resultTitle2: " a ",
    resultTitle3: " de ",
    resultTitle4: " Resultados",
    removeSelectedBtn: "Eliminar Seleccionados",
    approvalStatusHeader: "Estado de Aprobación",
    searchPlaceholder: "Buscar",
  },
});

// const selectRowProp = {
//   bgColor: "#eeeeee",
//   mode: "checkbox"
// };

class MultiSharing extends Component {
  constructor(props) {
    super(props);
    // this.renderDropdown = this.renderDropdown.bind(this);
    // Force Update
    // this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
    // this.reverseSnapshot = this.reverseSnapshot.bind(this);
    // this.renderBtn = this.renderBtn.bind(this);
    this.renderApprovalBtn = this.renderApprovalBtn.bind(this);
    this.checkStartDate = this.checkStartDate.bind(this);
    this.showNotification = this.showNotification.bind(this);
    this.checkEndDate = this.checkEndDate.bind(this);

    this.state = {
      multiSharingArray: [],
      adminNamesArray: [],
      loading: true,
      _notificationSystem: null,
      currentAllowAccessState: false,
    };
  }

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
  }

  componentWillMount() {
    //? retrieve super admin id
    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((eachSuperAdmin) => {
            const eachSuperAdminDetails = eachSuperAdmin.val();
            const members = eachSuperAdminDetails.members;
            let multiArray = [];
            let multiArrayDetail = {};
            let isMultiSharingAdminArray = [];
            // let permissionList = [];
            for (const member in members) {
              if (members[member].memberEmail === auth.currentUser.email) {
                const mySuperAdminId = eachSuperAdmin.key;
                if (mySuperAdminId !== null) {
                  //? retrieve all the user that has send permission to the current user
                  fire
                    .database()
                    .ref("retractableSharingRegistry")
                    .once("value")
                    .then((retractableSnapshot) => {
                      var count = 0;
                      retractableSnapshot.forEach(
                        (retractableChildSnapshot) => {
                          const retractableChildSnapshotVal = retractableChildSnapshot.val();

                          for (const eachShareData in retractableChildSnapshotVal) {
                            const key =
                              retractableChildSnapshotVal[eachShareData].id;
                            if (
                              retractableChildSnapshotVal[eachShareData]
                                .multiSharingAdmins !== undefined
                            ) {
                              isMultiSharingAdminArray =
                                retractableChildSnapshotVal[eachShareData]
                                  .multiSharingAdmins;

                              for (const eachAdmin in isMultiSharingAdminArray) {
                                if (
                                  isMultiSharingAdminArray[eachAdmin]
                                    .adminUid === auth.currentUser.uid &&
                                  isMultiSharingAdminArray[eachAdmin]
                                    .adminUid !== null
                                ) {
                                  count++;

                                  //? retrieve sender email
                                  fire
                                    .database()
                                    .ref("registeredUsersOnPlatform")
                                    .once("value")
                                    .then((usersSnapshot) => {
                                      usersSnapshot.forEach(
                                        (usersChildSnapshot) => {
                                          const usersChildSnapshotVal = usersChildSnapshot.val();
                                          const usersChildSnapshotKey =
                                            usersChildSnapshot.key;
                                          if (
                                            retractableChildSnapshotVal[
                                              eachShareData
                                            ].senderUID ===
                                            usersChildSnapshotKey
                                          ) {
                                            multiArrayDetail = {
                                              key: key,
                                              permissionAdminList:
                                                retractableChildSnapshotVal[
                                                  eachShareData
                                                ].multiSharingAdmins,
                                              lockName:
                                                retractableChildSnapshotVal[
                                                  eachShareData
                                                ].sharedLockName,
                                              lockSerial:
                                                retractableChildSnapshotVal[
                                                  eachShareData
                                                ].lockSerial,
                                              shareFrom: usersChildSnapshotVal,
                                              senderUID:
                                                retractableChildSnapshotVal[
                                                  eachShareData
                                                ].senderUID,
                                              shareTo:
                                                retractableChildSnapshotVal[
                                                  eachShareData
                                                ].sharedToEmail,
                                              shareStart:
                                                retractableChildSnapshotVal[
                                                  eachShareData
                                                ].shareStartTime,
                                              shareEnd:
                                                retractableChildSnapshotVal[
                                                  eachShareData
                                                ].shareEndTime,
                                              hasAllowed:
                                                retractableChildSnapshotVal[
                                                  eachShareData
                                                ].multiSharingAdmins[eachAdmin]
                                                  .hasAllowed,
                                              allowAccess:
                                                retractableChildSnapshotVal[
                                                  eachShareData
                                                ].allowAccess,
                                            };
                                            customLog(multiArrayDetail);
                                            multiArray.push(multiArrayDetail);
                                          }
                                        }
                                      );
                                    })
                                    .then(() => {
                                      this.setState({
                                        multiSharingArray: multiArray,
                                        loading: false,
                                        currentAllowAccessState:
                                          multiArrayDetail.hasAllowed,
                                      });
                                    })
                                    .catch((err) => customLog(err));
                                }
                              }
                            }
                          }
                        }
                      );
                      if (count === 0) {
                        this.setState({
                          multiSharingArray: [],
                          loading: false,
                          currentAllowAccessState: false,
                        });
                      }
                    });
                } else {
                  //show some message
                }
              }
            }
          });
        }
      });

    //! LANGUAGE SETTING
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  showNotification(msg, lvl) {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: <div>{msg}</div>,
      level: lvl,
      position: "tc",
      autoDismiss: 3,
    });
  }

  // reverseSnapshot(snapshot) {
  //   const jsonArray = [];
  //   let convertedJsonObject = {};

  //   snapshot.forEach(currVal => {
  //     jsonArray.push(currVal.val());
  //   });

  //   const reversedArr = jsonArray.reverse();
  //   reversedArr.forEach(currVal => {
  //     convertedJsonObject[currVal.id] = currVal;
  //   });

  //   return convertedJsonObject;
  // }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="searchBar"
        // id="retractSearch"
        placeholder={localizationStrings.searchPlaceholder}
      />
    );
  };

  // createCustomDeleteButton = onClick => {
  //   return (
  //     <Button
  //       bsSize="large"
  //       id="retractableBtn"
  //       style={{ width: "100%" }}
  //       onClick={onClick}
  //     >
  //       <i className="far fa-trash-alt" />{" "}
  //       {localizationStrings.removeSelectedBtn}
  //     </Button>
  //   );
  // };

  // Handler for Force Update
  // forceUpdateHandler() {
  //   this.forceUpdate();
  // }

  checkStartDate(shareStartTime) {
    if (shareStartTime === 0 || shareStartTime === "") {
      return "∞";
    } else {
      if (localizationStrings.getLanguage() === "ja") {
        var japanDate =
          new Intl.DateTimeFormat("ja-JP", {
            year: "numeric",
          }).format(shareStartTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            month: "numeric",
          }).format(shareStartTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            day: "numeric",
          }).format(shareStartTime * 1000);
        var japanTime = new Intl.DateTimeFormat("ja-JP", {
          hourCycle: "h12",
          hour: "numeric",
          minute: "2-digit",
        }).format(shareStartTime * 1000);
        return japanDate + " " + japanTime;
      } else {
        // return <TimeStamp time={shareStartTime} format="full" includeDay />;
        return <TimeStamp time={shareStartTime} format="full" />;
      }
    }
  }
  checkEndDate(shareEndTime) {
    if (shareEndTime === 0 || shareEndTime === "") {
      return "∞";
    } else {
      if (localizationStrings.getLanguage() === "ja") {
        var japanDate =
          new Intl.DateTimeFormat("ja-JP", {
            year: "numeric",
          }).format(shareEndTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            month: "numeric",
          }).format(shareEndTime * 1000) +
          new Intl.DateTimeFormat("ja-JP", {
            day: "numeric",
          }).format(shareEndTime * 1000);
        var japanTime = new Intl.DateTimeFormat("ja-JP", {
          hourCycle: "h12",
          hour: "numeric",
          minute: "2-digit",
        }).format(shareEndTime * 1000);
        return japanDate + " " + japanTime;
      } else {
        // return <TimeStamp time={shareEndTime} format="full" includeDay />;
        return <TimeStamp time={shareEndTime} format="full" />;
      }
    }
  }

  loadingData() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: "center" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <NoDataFound />
        </div>
      );
    }
  }

  // renderDropdown() {
  //   return _.map(this.state.multiSharingArray, accessData => {
  //     return <option value={accessData.key}>{accessData.lockName}</option>;
  //   });
  // }

  // renderBtn(accessData) {
  //   // customLog(accessData);
  //   return <SwitchBtn accessData={accessData} />;
  // }

  renderApprovalBtn(accessData) {
    return <ApprovalBtn accessData={accessData} />;
  }

  // renderApprovalBtn(cell, row) {
  //   return <ApprovalBtn cellValue={cell} rowValue={row} />;
  // }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const rData = _.map(this.state.multiSharingArray, (accessData) => {
      // customLog(accessData);
      return {
        key: accessData.key,
        lockName: accessData.lockName,
        lockSerial: accessData.lockSerial,
        shareFrom: accessData.shareFrom,
        senderUID: accessData.senderUID,
        shareTo: accessData.shareTo,
        shareStart: accessData.shareStart,
        shareEnd: accessData.shareEnd,
        hasAllowed: accessData.hasAllowed,
        access: accessData,
      };
    });

    const customTotal = (from, to, size) => (
      <span
        className="react-bootstrap-table-pagination-total"
        style={{ float: "right" }}
      >
        {localizationStrings.resultTitle1}
        {from}
        {localizationStrings.resultTitle2}
        {to}
        {localizationStrings.resultTitle3}
        {size}
        {localizationStrings.resultTitle4}
      </span>
    );

    const options = {
      sizePerPageDropDown: this.renderSizePerPageDropDown,
      page: 1, // which page you want to show as default
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "100",
          value: 100,
        },
        {
          text: "All",
          value: rData.length,
          // value: this.state.multiSharingArray.length
        },
      ], // you can change the dropdown list for size per page
      sizePerPage: 10, // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      paginationSize: 3, // the pagination bar size.
      prePage: "<", // Previous page button text
      nextPage: ">", // Next page button text
      firstPage: "<<", // First page button text
      lastPage: ">>", // Last page button text
      paginationShowsTotal: customTotal,
      noDataText: this.loadingData(),
      // deleteBtn: this.createCustomDeleteButton, // Accept bool or function
      // default is bottom, top and both is all available
      // hideSizePerPage: true > You can hide the dropdown for sizePerPage
      // alwaysShowAllBtns: true // Always show next and previous button
      // withFirstAndLast: false > Hide the going to First and Last page button// A hook for after droping rows.
      searchField: this.createCustomSearchField,
    };

    const columnHover = (cell, row, enumObject, rowIndex) => {
      return cell;
    };

    return (
      <div
        style={{
          maxWidth: "95%",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <NotificationSystem ref="notificationSystem" style={style} />
        <div className="search">
          <div className="header">
            <h2>{localizationStrings.multiApproveTitle}</h2>
          </div>
          <div>
            <h4>{localizationStrings.multiApproveDescription}</h4>
          </div>
        </div>
        <br />
        <br />

        <div>
          <BootstrapTable
            pagination={true}
            search
            bordered={false}
            data={rData}
            // data={this.state.multiSharingArray}
            // selectRow={selectRowProp}
            // deleteRow
            options={options}
          >
            <TableHeaderColumn dataField="key" isKey={true} hidden>
              Key
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="lockName"
              dataSort
              columnTitle={columnHover}
            >
              {localizationStrings.lockNameHeader}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="lockSerial"
              dataSort
              columnTitle={columnHover}
              dataFormat={(cell, row) =>
                row.lockSerial === "group" ? "N/A (Lock Group)" : cell
              }
            >
              {localizationStrings.lockSerialHeader}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="shareFrom"
              dataSort
              columnTitle={columnHover}
            >
              {localizationStrings.shareFromHeader}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="shareTo"
              dataSort
              columnTitle={columnHover}
            >
              {localizationStrings.shareToHeader}
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="shareStart"
              dataFormat={this.checkStartDate}
              // columnTitle={this.checkStartDate}
              tdStyle={{ whiteSpace: "normal" }}
            >
              {localizationStrings.startHeader}
            </TableHeaderColumn>

            <TableHeaderColumn
              dataField="shareEnd"
              dataFormat={this.checkEndDate}
              // columnTitle={this.checkEndDate}
              tdStyle={{ whiteSpace: "normal" }}
            >
              {localizationStrings.endHeader}
            </TableHeaderColumn>

            {/* <TableHeaderColumn dataField="access" dataFormat={this.renderBtn}>
              {localizationStrings.allowAccessHeader}
            </TableHeaderColumn> */}

            <TableHeaderColumn
              dataField="access"
              dataFormat={this.renderApprovalBtn}
            >
              {localizationStrings.approvalStatusHeader}
            </TableHeaderColumn>
          </BootstrapTable>
          <br />
        </div>
        <div className="empty-space"></div>
        {/* <Chatbot/> */}
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(MultiSharing);
